import { observable, runInAction, makeObservable } from 'mobx';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { PortalStore } from '../portal/portalStore/PortalStore';
import { LehrerStore } from './LehrerStore';
import { SchuelerStore } from './SchuelerStore';
import { StatistikStore } from './StatistikStore';
import { InfoStore } from './InfoStore';
import { PortalEnv } from '../../env/PortalEnv';
import { Env } from '../../env/Env';
import { RequestStore } from './RequestStore/RequestStore';
import { UserStore } from './UserStore/UserStore';
import { TopicStore } from './TopicStore';
import { TopicPageStore } from './TopicPageStore';

export class Store {
  readonly type = 'store';

  readonly env: Env;
  @observable.ref appComponent: any;

  constructor({ env }: { env?: Env } = {}) {
    makeObservable(this);
    this.env = env;
  }

  @memoize
  get requestStore() {
    return new RequestStore(this);
  }

  @memoize
  get userStore() {
    return new UserStore(this);
  }

  @memoize
  get portalStore() {
    return new PortalStore(this);
  }

  @memoize
  get lehrerStore() {
    return new LehrerStore(this);
  }

  @memoize
  get schuelerStore() {
    return new SchuelerStore(this);
  }

  @memoize
  get statistikStore() {
    return new StatistikStore(this);
  }

  @memoize
  get infoStore() {
    return new InfoStore(this);
  }

  @memoize
  get topicStore() {
    return new TopicStore(this);
  }

  @memoize
  get topicPageStore() {
    return new TopicPageStore(this);
  }

  get storeData(): Env['transfer'] {
    if (this.appComponent) {
      // browser
      return this.appComponent.props as any;
    }
    return this.env.transfer; // env
  }

  /*
  @memoize
  get setupStore() {
    return new SetupStore(this);
  }
*/

  static forApp(appComponent) {
    // could be used for dependency injection (get Storage intensive Classes from AppComponent)
    const store = Store.store;

    runInAction(() => {
      store.appComponent = appComponent;
      appComponent.setupPage(store);
    });

    return store;
  }

  static get store(): Store {
    if (typeof window !== 'undefined' && window.store) {
      return window.store;
    }
    const store = new Store();
    if (typeof window !== 'undefined') {
      window.store = store;
    }
    return store;
  }
}
